import React from 'react';

import VideoDataTable from '../components/DataTable/VideoDataTable';
import PageFrame from '../layouts/PageFrame';

function VideoList() {
    return (
        <PageFrame type="videos">
            <VideoDataTable />
        </PageFrame>
    );
}

export default VideoList;
